<template>
  <div :id="'echarts-status-produto'" style="width: 100%; height: 100%;"></div>
</template>

<script>
import { nextTick } from "vue";
import * as echarts from 'echarts';
import { opcoes } from './Opcoes';

let myChart;

export default {
  props: {
    dados: {
      type: [Array, Object],
      required: true
    }
  },
  mounted() {
    const chartDom = document.getElementById('echarts-status-produto');
    myChart = echarts.init(chartDom);
    async () => {
      await nextTick();
      myChart.resize();
    }
    this.redimencionarGraficoSempreQueTamanhoTelaMudar();
  },
  watch: {
    dados() {
      this.atualizarDadosGrafico();
      myChart.resize();
    }
  },
  methods: {
    redimencionarGraficoSempreQueTamanhoTelaMudar() {
      window.addEventListener('resize', function() {
        myChart.resize();
      });
    },
    atualizarDadosGrafico() {
      this.dados.grafico.dados_grafico.map(m => m.label.formatter = (v) => v.value.replace('.', ',') + '%');

      const _opcoes = {
        ...opcoes,
        xAxis: {
          ...opcoes.xAxis,
          data: this.dados.grafico.labels_grafico,
          show: false,
          axisLine: {
            show: false
          }
        },
        series: this.dados.grafico.dados_grafico
      };

      myChart.setOption(_opcoes);
      myChart.resize();
    }
  }
}
</script>
